import React from 'react';
import { useAuthStore, useDeviceGroupsStore, useRoutesStore } from 'store';
import { useNavigate } from 'react-router-dom';
import { buildNavigatePath } from '../utils';
import { IconTextButton } from 'ui-lib/components/buttons/icon-text-button';
import { AccountType } from 'dto/access-management/account-dto';

export interface IDeviceGroupHyperlinkProps {
    deviceGroupName: string;
}

export const DeviceGroupHyperlink = (props: IDeviceGroupHyperlinkProps) => {
    const deviceGroupsStore = useDeviceGroupsStore();
    const { currentUser } = useAuthStore();
    const routeStore = useRoutesStore();
    const navigate = useNavigate();
    const clientAccount = deviceGroupsStore.getClientOwnDeviceGroup(props.deviceGroupName);
    return (
        <IconTextButton
            type='primary'
            label={'Go to device group'}
            onClick={() =>
                navigate({
                    pathname: buildNavigatePath(routeStore.getRoute('DEVICES_DEVICE_GROUPS').path),
                    search: currentUser.accountType === AccountType.CLIENT ? '' : `?accountUuid=${clientAccount.uuid}`,
                })
            }
        />
    );
};
